// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

// ** Credit
export const getCreditsList = createAsyncThunk('appCredits/getCreditsList', async params => {
   params.page = params.page === 0 ? 0 : params.page - 1
   const response = await axios.get(apiLink('getCreditsList', params))

   return {
      params,
      data: response.data.credits,
      totalPages: response.data.total_elements
   }
})
export const getCredit = createAsyncThunk('appCredits/getCredit', async id => {
   const response = await axios.get(apiLink({name: 'getCredit', value: id}))
   return response.data
})
export const addCredit = createAsyncThunk('appCredits/addCredit', async (data) => {
   const response = await axios.post(apiLink('addCredit'), data)
   return response.data
})
export const editCredit = createAsyncThunk('appCredits/editCredit', async (data) => {
   const id = data.id
   delete data.id
   const response = await axios.put(apiLink({name: 'editCredit', value: id}), data)
   return response.data
})
export const editCreditPaymentDate = createAsyncThunk('appCredits/editCreditPaymentDate', async (data) => {
   const id = data.id
   delete data.id
   const response = await axios.put(apiLink({name: 'editCreditPaymentDate', value: id}, data))
   return response.data
})
export const getCreditPeriods = createAsyncThunk('appCredits/getCreditPeriods', async id => {
   const response = await axios.get(apiLink({name: 'getCreditPeriods', value: id}))
   return response.data
})
export const crediStatusFinished = createAsyncThunk('appCredits/crediStatusFinished', async id => {
   const response = await axios.post(apiLink({name: 'changeCreditStatus', value: id}, {status: 'FINISHED', archive: true}))
   return response.data
})
export const crediStatusAnnulled = createAsyncThunk('appCredits/crediStatusAnnulled', async id => {
   const response = await axios.post(apiLink({name: 'changeCreditStatus', value: id}, {status: 'ANNULLED', archive: true}))
   return response
})
export const crediStatusSeized = createAsyncThunk('appCredits/crediStatusSeized', async id => {
   const response = await axios.post(apiLink({name: 'changeCreditStatus', value: id}, {status: 'SEIZED', archive: true}))
   return response.data
})
export const recalculateCredit = createAsyncThunk('appCredits/recalculateCredit', async id => {
   const response = await axios.post(apiLink({name: 'recalculateCredit', value: id}))
   return response.data
})
export const calculateCredit = createAsyncThunk('appCredits/calculateCredit', async id => {
   const response = await axios.post(apiLink({name: 'calculateCredit', value: id}))
   return response.data
})
export const calculateTotalAmount = createAsyncThunk('appCredits/calculateTotalAmount', async (data) => {
   const response = await axios.post(apiLink('calculateTotalAmount'), data)
   return response.data
})
export const getCreditAdditionalExpenses = createAsyncThunk('appCredits/getCreditAdditionalExpenses', async id => {
   const response = await axios.get(apiLink({name: 'additionalExpensesList', value: id}))
   return response.data
})
export const AddAdditionalExpense = createAsyncThunk('appCredits/AddAdditionalExpense', async (data) => {
   const id = data.credit_id
   delete data.credit_id
   const response = await axios.post(apiLink({name: 'addAdditionalExpense', value: id}), data)
   return response.data
})
export const removeCreditAdditionalExpense = createAsyncThunk('appCredits/removeCreditAdditionalExpense', async (id) => {
   const response = await axios.delete(apiLink({name: 'removeAdditionalExpense', value: id}, {type: 'CREDIT'}))
   return response.data
})

export const changeNoteCreditStatus = createAsyncThunk('appCredits/changeNoteCreditStatus', async (data) => {
   const response = await axios.put(apiLink({name: 'changeNoteCreditStatus', value: data.id}, {note_status: data.status}, false))   
   return response.data
})

// ** Payments
export const addPayment = createAsyncThunk('appCredits/addPayment', async (data) => {
   return await axios.post(apiLink('addPayment'), data)
})
export const removeCreditPayment = createAsyncThunk('appCredits/removeCreditPayment', async (id) => {
   const response = await axios.delete(apiLink({name: 'removePayment', value: id}, {type: 'CREDIT'}))
   return response.data
})

// ** First payment payments
export const getFirstPayemntPayments = createAsyncThunk('appCredits/getFirstPayemntPayments', async id => {
   const response = await axios.get(apiLink({name: 'getFirstPayemntPayments', value: id}))
   return response.data
})
export const removeFirstPaymentPayment = createAsyncThunk('appCredits/removeFirstPaymentPayment', async (id) => {
   const response = await axios.delete(apiLink({name: 'removePayment', value: id}, {type: 'FIRST_PAYMENT_CREDIT'}))
   return response.data
})

// ** Deposts
export const removeDepositPayment = createAsyncThunk('appCredits/removeDepositPayment', async (id) => {
   const response = await axios.delete(apiLink({name: 'removePayment', value: id}, {type: 'DEPOSIT'}))
   return response.data
})
export const addDynamicDeposit = createAsyncThunk('appCredits/addDynamicDeposit', async data => {
   const id = data.credit_id
   delete data.credit_id
   const response = await axios.post(apiLink({name: 'addCreditDynamicDeposit', value: id}), data)
   return response.data
})
export const removeDynamicDeposit = createAsyncThunk('appCredits/removeDynamicDeposit', async (id) => {
   const response = await axios.delete(apiLink({name: 'removeDynamicDeposit', value: id}))
   return response.data
})

// Media files
export const getMedia = createAsyncThunk('appCredits/getMedia', async ({credit_id, types}) => {
   const response = await axios.post(apiLink('getFiles', {typeOwner: 'CREDIT'}), {
      ids: [credit_id],
      types
   })
   return {files: response.data.files, credit_id}
})
export const addMedia = createAsyncThunk('appCredits/addMedia', async ({credit_id, type, typeOwner, file}) => {
   const response = await axios({
        method: "post",
        url: apiLink({name: 'uploadFile', value: credit_id}, {type, typeOwner}),
        data: { file },
        headers: { "Content-Type": "multipart/form-data" }
      })
   return response.data
})
export const removeMedia = createAsyncThunk('appCredits/removeMedia', async (id) => {
   const response = await axios.delete(apiLink({name: 'removeFile', value: id}, {typeOwner: 'CREDIT'}))
   return {id, status: response.status}
})

// ** Customers list
export const getCreditsCustomers = createAsyncThunk('appCredits/getCreditsCustomers', async () => {
   const params = {active: true, sort_list: 'first_name', sort_order: 'ASC', rows: 1000, blacklist: false}
   const response = await axios.get(apiLink('getCustomersShortList', params))
   return response.data.customers
})
// ** Cars list
export const getCreditsCars = createAsyncThunk('appCredits/getCreditsCars', async () => {
   const params = {sort_list: 'id', sort_order: 'ASC', rows: 1000, statuses: 'BASE,SHOWCASE', has_customer: false, in_road_accident_lock: false}
   const response = await axios.get(apiLink('getCarsShortList', params))
   return response.data.cars
})

// ** Credit Settings
export const getCreditSettings = createAsyncThunk('appCredits/getCreditSettings', async () => {
   const response = await axios.get(apiLink('getCreditSettings'))
   return response.data.creditSettings
})
export const addCreditSettings = createAsyncThunk('appCredits/addCreditSettings', async (data) => {
   delete data.id
   const response = await axios.post(apiLink('addCreditSettings'), data)
   return response.data
})
export const updateCreditSettings = createAsyncThunk('appCredits/updateCreditSettings', async (data) => {
   const preset_id = data.id
   delete data.id
   const response = await axios.put(apiLink({name: 'updateCreditSettings', value: preset_id}), data)
   return response.data
})
export const removeCreditSettings = createAsyncThunk('appCredits/removeCreditSettings', async (id) => {
   const response = await axios.delete(apiLink({name: 'removeCreditSettings', value: id}))
   return response.data
})

// ** Daily report
export const creditDailyReport = createAsyncThunk('appCredits/creditDailyReport', async data => {   
   const response = await axios.post(`https://api.mfauto.com.ua/report/credit-daily?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const getCreditsAdditinalExpensesReport = createAsyncThunk('appCredits/getCreditsAdditinalExpensesReport', async params => {   
   params.page = params.page === 0 ? 0 : params.page - 1
   const response = await axios.post(`https://api.mfauto.com.ua/report/credit-additional-expenses?env=${process.env.REACT_APP_NODE_ENV}`, params)

   return {
      params,
      data: response.data.credits,
      totalPages: response.data.total_elements
   }
})

// ** Mark visit
export const creditPeriodVisited = createAsyncThunk('appCredits/creditPeriodVisited', async data => {
   const id = data.period_id
   delete data.period_id
   const response = await axios.post(apiLink({name: 'creditPeriodVisited', value: id}, data))
   return response.data
})

// ** Credit agreements
export const getAgreements = createAsyncThunk('appCredits/getAgreements', async data => {   
   const response = await axios.post(`https://api.mfauto.com.ua/agreements/get?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const registerCreditExtension = createAsyncThunk('appCredits/registerCreditExtension', async data => {   
   const response = await axios.post(`https://api.mfauto.com.ua/credit/register-extension?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Credit Options
export const getCreditOptions = createAsyncThunk('appCredits/getCreditOptions', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/credit/get-options?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})
export const updateCreditOptions = createAsyncThunk('appCredits/updateCreditOptions', async (data) => {
   const response = await axios.post(`https://api.mfauto.com.ua/credit/update-options?env=${process.env.REACT_APP_NODE_ENV}`, data)
   return response.data
})

// ** Credit payments list
export const getCreditPaymentsList = createAsyncThunk('appCredits/getCreditPaymentsList', async params => {
   params.page = params.page === 0 ? 0 : params.page - 1
   const response = await axios.post(`https://api.mfauto.com.ua/credit/payments?env=${process.env.REACT_APP_NODE_ENV}`, {
      ...params,
      token: localStorage.getItem('token')
   })
   return {
      params,
      data: response.data.credits,
      totalPages: response.data.total_elements
   }
})

export const appCreditsSlice = createSlice({
  name: 'appCredits',
  initialState: {
    data: [],
    total: 1,
    params: {},
    settings: [],
    selectedCredit: null,
    customers: [],
    cars: [],
    media: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getCreditsList.fulfilled, (state, action) => {
         state.data = action.payload.data
         state.params = action.payload.params
         state.total = action.payload.totalPages
      })
      .addCase(getCreditPaymentsList.fulfilled, (state, action) => {
         state.data = action.payload.data
         state.params = action.payload.params
         state.total = action.payload.totalPages
      })
      .addCase(getCredit.fulfilled, (state, action) => {
         state.selectedCredit = action.payload
      })
      .addCase(getCreditSettings.fulfilled, (state, action) => {
         state.settings = action.payload
      })
      .addCase(updateCreditSettings.fulfilled, (state, action) => {
         state.settings = action.payload
      })
      .addCase(getCreditsCustomers.fulfilled, (state, action) => {
         state.customers = action.payload
      })
      .addCase(getCreditsCars.fulfilled, (state, action) => {
         state.cars = action.payload
      })
      .addCase(changeNoteCreditStatus.fulfilled, (state, action) => {
         state.selectedCredit = action.payload         
      })
      .addCase(getMedia.fulfilled, (state, action) => {
         const uniqueMedia = [...state.media, ...action.payload.files].reduce((accumulator, current) => {
            if (!accumulator.find((item) => item.file_id === current.file_id)) {
               accumulator.push(current)
            }
            return accumulator
         }, [])
         state.media = uniqueMedia.filter((item) => item.customer_id === action.payload.customer_id)
      })
      .addCase(removeMedia.fulfilled, (state, action) => {
         if (action.payload.status === 200) {
            state.media = state.media.filter(item => item.file_id !== action.payload.id)
         }
      })      
      .addCase(getCreditsAdditinalExpensesReport.fulfilled, (state, action) => {
         state.data = action.payload.data
         state.params = action.payload.params
         state.total = action.payload.totalPages
      })
  }
})

export default appCreditsSlice.reducer
